var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendDownRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8379 15.3039L21.4094 18.7857C21.3589 19.1806 21.02 19.4747 20.6222 19.4719H17.132C16.6979 19.4747 16.3449 19.1274 16.3393 18.6932C16.3393 18.2647 16.6979 17.9145 17.132 17.9145H19.0144L14.0284 10.9649L7.23569 13.8921C6.86034 14.049 6.42617 13.9061 6.21888 13.5588L2.2581 6.69322C2.04521 6.31787 2.17687 5.84448 2.55222 5.6316C2.55502 5.6288 2.55782 5.6288 2.56062 5.626C2.94157 5.41591 3.42056 5.54476 3.63905 5.92011L7.2497 12.175L13.9808 9.28146C14.3253 9.1302 14.7287 9.23944 14.95 9.54476L20.0676 16.6904L20.2581 15.1162C20.3197 14.6848 20.7119 14.3795 21.1461 14.4299C21.5746 14.4775 21.8855 14.8669 21.8379 15.2955V15.3039Z",
    fill: "#0B2739"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendDownRegular);
export default __webpack_public_path__ + "static/media/trend-down-regular.ab2f04e5b368b61e2f26f6fec0d6e7cc.svg";
export { ForwardRef as ReactComponent };